interface Environment {
    stage: string;
    host: string;
}

export const getUrlPrefix = (country: string, env: Environment) => {
    if (env.stage === 'Production') {
        return 'https://' + env.host;
    }
    if (country === 'AU') {
        return 'https://archipro.com.au'; // use production for testing purposes
    }
    return 'https://archipro.co.nz'; // use production for testing purposes
};
